import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Adaptive version routing wrapper.
 * Renders v2 if active and available, otherwise gracefully falls back to v1.
 */
export default function VersionRoute({ v1, v2 }) {
  const version = useSelector((state) => state.uiVersion?.version || 'v2');

  if (version === 'v2' && v2) {
    return <>{v2}</>;
  }

  return <>{v1}</>;
}
